<template>
    <div class="">
        <a href="#!" @click="$emit('toview')">View</a>
        <br>
        <a style="" class="btn savebutton" @click="savePostHandler">
            <i class="material-icons">save</i>
            <span style="margin-left:3px;transform:translate(0px,-4px);display:inline-block;">Save</span>
        </a>
        <a style="" class="btn" @click="dup">
            <i class="material-icons">file_copy</i>
            <span style="margin-left:3px;transform:translate(0px,-4px);display:inline-block;">clone</span>
        </a>
        Title:<br>
        <h3 ref="title" style="border-bottom:1px solid grey;" contenteditable="true">{{ title }}</h3>
        <div style="width:30%;float:left;">
            <NotesListL2
                :edit="true"
                :notelist="tree"
                @newfile="newFileHandler"
            />
        </div>
        <div style="width:69%;float:left;">
            <NoteEditL2 v-if="edit"
                :key="forceRefreshEdit"
                @saveFile="saveFileHandler"
                @delFile="delFileHandler"
                :treeObj="treeObj"/>
            <!-- <MKRender 
                v-if="treeSelected"
                :key="this.treeObj.title"
                :source="treeObj.content"/> -->
        </div>
    </div>
</template>

<script>
import MKRender from '../MKRender/main'
import NotesListL2 from '../NotesListL2/main'
import NoteEditL2 from '../NoteEditL2/main'

export default {
    name: '',
    props: ['noteSelected'],
    components: {
        MKRender,
        NotesListL2,
        NoteEditL2,
    },
    data(){
        return {
            forceRefreshEdit: 0,
            edit: false,
            title: '',
            tree: [], // path, content
            treeSelected: null,
            treeObj: {
                title: '',
                content: '',
            },
        }
    },
    beforeMount(){
        console.log('notedetail', this.noteSelected)
        this.title = this.noteSelected.title
        if (this.noteSelected.key){
            this.axios.get(this.$apiprefix+'/get/'+this.$col+'/'+this.noteSelected.key).then(rs => {
                console.log(rs.data)
                this.title = rs.data.title
                this.tree = rs.data.tree || []
                rs.data.tree = rs.data.tree.sort((a,b) => {
                    return a.title < b.title ? -1 : 1
                })
            })
        }
        window.newFile = this.newFileHandler
        window.fileClick = this.newFileHandler
    },
    mounted(){
    },
    methods: {
        dup(){
            if (this.noteSelected.key){
                delete this.noteSelected.key
                this.send_toast('cloned!')
            }
        },
        newFileHandler(title=''){
            console.log('new file handler', title)
            if (title != ''){
                let treeObj = this.tree.filter(d => d.title == title)
                if (treeObj.length == 1){
                    treeObj = treeObj[0]
                    console.log('treeobj', treeObj)
                    this.treeSelected = title
                    this.treeObj = treeObj
                    this.edit = true
                    this.forceRefreshEdit++
                    return
                }
            }
            let treeObj = {
                title: title,
                content: '',
            }
            // this.tree.push(treeObj)
            this.forceRefreshEdit++
            this.treeSelected = title
            this.treeObj = treeObj
            this.edit = true
        },
        savePostHandler(){
            const payload = {
                key: this.noteSelected.key,
                title: this.$refs.title.innerHTML,
                tree: this.tree,
            }
            this.axios.post(this.$apiprefix+'/post/'+this.$col, payload).then(rs => {
                this.noteSelected.key = rs.data.key
                this.noteSelected.title = rs.data.title
                document.querySelectorAll('.savebutton').forEach(b => {
                    b.classList.remove('orange')
                })
                // window.history.pushState({}, null, '/notes')
                this.send_toast('Save ok', 'ok')
            }).catch(err => {
                this.send_toast(err, 'err')
            })
        },
        delFileHandler(){
            this.tree = this.tree.filter(d => d.title != this.treeObj.title)
            this.edit = false
            this.treeObj = {
                title: '',
                content: '',
            }
            this.forceRefreshEdit++
        },
        saveFileHandler(obj){
            console.log('main save post', obj)
            this.tree = [
                ...this.tree.filter(d => d.title != obj.oldtitle && d.title != obj.title),
                {
                    title: obj.title,
                    content: obj.content,
                },
            ].sort((a,b) => {return a.title < b.title ? -1 : 1})
            this.send_toast('Local save ok', 'ok')
            this.savePostHandler()
        }
    },
}
</script>

<style>

</style>